import { isUuid } from '../../string';

const DEFAULT_PAGE_NAME = 'default';

/*
 * Преобразует путь URL в название страницы для RUM
 * Заменяет реальный идентификатор UUID на строку "uuid"
 *
 * @example
 * /dashboards → dashboards
 * /settings/managers → settings-managers
 * /product/019bffa3-30ee-7b6e-a3aa-3225d56b0afe → product-uuid
 */

export const pathToPageName = (path: string = DEFAULT_PAGE_NAME): string => {
    const result = path.split('/').reduce((acc, segment) => {
        if (!segment) {
            return acc;
        }

        const part = isUuid(segment) ? 'uuid' : segment;

        return acc ? `${acc}-${part}` : part;
    }, '');

    return result || DEFAULT_PAGE_NAME;
};
